import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';

import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';

import analytics from './analytics';
import SpinnerView from './components/SpinnerView';
import type { IWindow } from './interfaces/window.interface';
import { logException } from './utils';

import './index.css';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window extends IWindow {}
}

const App = lazy(() => import('./components/App'));

/**
 * Configure third-party
 */

if (window.Raven && process.env.REACT_APP_SENTRY_DSN && !window.Cypress) {
  window.Raven.config(process.env.REACT_APP_SENTRY_DSN, {
    release: process.env.PUBLIC_URL,
  }).install();
}

// Load Segment
if (process.env.REACT_APP_SEGMENT_WRITE_KEY && !window.Cypress) {
  analytics.load(process.env.REACT_APP_SEGMENT_WRITE_KEY);
}

// Load Zendesk
setTimeout(() => {
  const s = document.createElement('script');
  s.id = 'ze-snippet';
  s.src = `https://static.zdassets.com/ekr/snippet.js?key=${process.env.REACT_APP_ZENDESK_KEY}`;
  s.onerror = logException;
  document.head.appendChild(s);
}, 2500);

/**
 * Mount the app
 */
ReactDOM.render(
  <Router>
    <Suspense fallback={<SpinnerView data-testid="App_spinner" />}>
      <Switch>
        <Route component={App} />
      </Switch>
    </Suspense>
  </Router>,
  document.getElementById('root')
);
